import { bindable } from 'aurelia-framework';

class ProductFeedsProductsList {
  @bindable loading = false;
  @bindable account = null;
}

export { ProductFeedsProductsList };
